import { Crown, Dices, Gamepad2, Grid2X2, Layers, Moon, Radar, Swords } from "lucide-react";
import { Link } from "react-router-dom";

const GAMES = [
  { to: "/wasteland-run", name: "WASTELAND RUN", tag: "Outrun the worm", icon: Gamepad2, testid: "hub-wasteland-run", art: "run" },
  { to: "/riotball", name: "AL RIOTBALL", tag: "60-second arena", icon: Swords, testid: "hub-riotball", art: "riot" },
  { to: "/side-games#dolosway", name: "DOLOSWAY", tag: "Digital board game", icon: Dices, testid: "hub-dead-highway", art: "dice" },
  { to: "/tcg", name: "TCG ARENA", tag: "Build. Battle. Bank PTS.", icon: Layers, testid: "hub-tcg-arena", art: "tcg" },
  { to: "/dolopals#dolo-bingo", name: "DOLO BINGO", tag: "Caller grid · weekly race", icon: Crown, testid: "hub-dolo-bingo", art: "bingo" },
  { to: "/side-games#dolos-night", name: "DOLO'S NIGHT", tag: "Survive the maze", icon: Moon, testid: "hub-dolos-night", art: "night" },
  { to: "/dolopals", name: "DOLOPALS RADAR", tag: "Catch signals & critters", icon: Radar, testid: "hub-dolopals-radar", art: "radar" },
  { to: "/dolopals?play=match", name: "CRITTER MATCH", tag: "Pairs on a speeding clock", icon: Grid2X2, testid: "hub-critter-match", art: "match" },
];

/* The arcade lineup in one slim strip. */
export function GamesHub() {
  return (
    <section className="games-hub" data-testid="games-hub">
      <div className="games-hub-head">
        <p className="eyebrow">BLACK-OPS NET ARCADE // FULL LINEUP</p>
        <h2>EIGHT GAMES. ONE APP.</h2>
      </div>
      <div className="games-hub-grid">
        {GAMES.map((g, i) => (
          <Link key={g.name} to={g.to} className={`games-hub-tile art-${g.art}`} style={{ "--i": i }} data-testid={g.testid}>
            <g.icon size={18} />
            <strong>{g.name}</strong>
            <span>{g.tag}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
